module.exports = __webpack_public_path__ + "static/jenny_zhang-027ad68d4800d8c82822dd27d5c23968.jpg";